module.exports = __webpack_public_path__ + "static/media/cat.d3a05750.jpg";